import { Box, Button, styled } from '@mui/material';

export const SidebarContainer = styled(Box)`
  & > div:first-child {
    padding: 0 16px;
  }

  padding: 20px 0 0 0;
  height: 100vh;
  overflow-y: auto;
`;

export const SectionContainer = styled(Box)`
  padding: 10px;
  margin: 10px;
`;

export const CreateButtonWrapper = styled(Box)`
  display: flex;
  margin-top: 20px;
  gap: 20px;
`;

export const CreateComponentButton = styled(Button)(
  ({ theme }) => `
  min-width: 126px;
  border: 1px solid;
  color: ${theme.palette.primary.main};
  background-color: white;

  & path {
    fill: ${theme.palette.primary.main};
  }
`,
);
